import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1a1a1a] text-white pt-16 pb-8 border-t border-[#333]" data-id="element-54">
      <div className="container mx-auto px-4" data-id="element-55">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-56">
          {/* Brand */}
          <div className="space-y-4" data-id="element-57">
            <div className="flex items-center gap-2" data-id="element-58">
              <div className="w-8 h-8 bg-[#FDB913] rounded flex items-center justify-center text-[#1a1a1a] font-bold" data-id="element-59">
                P
              </div>
              <span className="font-bold text-lg" data-id="element-60">PRECISION PRO</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-61">
              Providing industrial efficient sprayers for mold remediation,
              water restoration, and agricultural applications.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-62">
            <h4 className="text-[#FDB913] font-bold uppercase tracking-wider mb-6" data-id="element-63">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-64">
              <li data-id="element-65">
                <Link to="/" className="text-gray-400 hover:text-white transition-colors" data-id="element-66">
                  Home
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/#products" className="text-gray-400 hover:text-white transition-colors" data-id="element-68">
                  Shop Products
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/cart" className="text-gray-400 hover:text-white transition-colors" data-id="element-70">
                  My Cart
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-72">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-73">
            <h4 className="text-[#FDB913] font-bold uppercase tracking-wider mb-6" data-id="element-74">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-75">
              <li className="flex items-start gap-3 text-gray-400" data-id="element-76">
                <MapPin className="w-5 h-5 text-[#FDB913] mt-0.5" data-id="element-77" />
                <span data-id="element-78">
                  123 Industrial Park Dr,
                  <br data-id="element-79" />
                  Builder City, ST 12345
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-80">
                <Phone className="w-5 h-5 text-[#FDB913]" data-id="element-81" />
                <a href="tel:555-123-4567" className="hover:text-white" data-id="element-82">
                  555-123-4567
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-83">
                <Mail className="w-5 h-5 text-[#FDB913]" data-id="element-84" />
                <a href="mailto:sales@precisionpro.com" className="hover:text-white" data-id="element-85">
                  sales@precisionpro.com
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-86">
            <h4 className="text-[#FDB913] font-bold uppercase tracking-wider mb-6" data-id="element-87">
              Follow Us
            </h4>
            <div className="flex gap-4" data-id="element-88">
              <a href="#" className="bg-[#333] p-2 rounded-full hover:bg-[#FDB913] hover:text-black transition-colors" data-id="element-89">
                <Facebook size={20} data-id="element-90" />
              </a>
              <a href="#" className="bg-[#333] p-2 rounded-full hover:bg-[#FDB913] hover:text-black transition-colors" data-id="element-91">
                <Instagram size={20} data-id="element-92" />
              </a>
              <a href="#" className="bg-[#333] p-2 rounded-full hover:bg-[#FDB913] hover:text-black transition-colors" data-id="element-93">
                <Twitter size={20} data-id="element-94" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#333] pt-8 text-center text-gray-500 text-sm" data-id="element-95">
          <p data-id="element-96">
            &copy; {new Date().getFullYear()} Precision Pro Sprayers. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}